module.exports = function(stripeElement, options) {
	var $ = jQuery
	var controller = {}

	if(!options) {
		options = {}
	}
	options.delay = options.delay || 2000
	options.gutter = options.gutter = 0
	var $stripe = $(stripeElement)
	controller.options = options
	controller.$stripe = $stripe

	// pic stripe
	var goLeft = function() {
		var $moveable = $stripe.find('.moveable');
		var $img1 = $	($moveable.find('.move-element').last());
		var change = $img1.width() + options.gutter;
		$moveable.css('margin-left', '-' + change + 'px');
		$moveable.prepend($img1);
		
		$moveable.animate({
			'margin-left': '0'
		}, 'linear', function() {
			$moveable.css('margin-left', '');
		});
	}
	var goRight = function() {
		var $moveable = $stripe.find('.moveable');
		var $img1 = $	($moveable.find('.move-element')[0]);
		var change = $img1.width() + options.gutter;
		$moveable.animate({
			'margin-left': '-' + change + 'px',
			'margin-right': change + 'px'
		}, 'linear', function() {
			$img1.remove();
			$moveable.css('margin-left', '');
			$moveable.css('margin-right', '');
			$moveable.append($img1);
		});
	}

	controller.goLeft = goLeft
	controller.goRight = goRight
	

	controller.doAdvance = true;
	
	$stripe.find('.go-left').click(function(evt){
		controller.doAdvance = false;
		goLeft();
	});
	$stripe.find('.go-right').click(function(evt){
		controller.doAdvance = false;
		goRight();
	});
	
	controller.intervalNum = setInterval(function() {
		if(!controller.doAdvance) {
			controller.doAdvance = true;
			return;
		}
		goRight();
	}, options.delay);
	

	return controller
}
